<template>
  <div>
    <div class="rounded-2xl bg-gradient-to-r from-blue-600 to-indigo-700 shadow-xl p-8 text-white relative overflow-hidden mb-8">
      <div class="absolute inset-0 bg-black opacity-5" aria-hidden="true" />
      <div class="relative z-10">
        <h1 class="text-2xl md:text-3xl font-bold flex items-center gap-3">
          <font-awesome-icon icon="calendar-week" class="opacity-90" />
          Timetable
        </h1>
        <p class="text-blue-100 mt-3 max-w-3xl leading-relaxed">
          View your weekly classes, times, and room locations in one place.
        </p>
      </div>
    </div>

    <div class="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 sm:p-8 space-y-6">
      <h2 class="text-lg font-semibold text-gray-900">Your classes</h2>
      <p class="text-sm text-gray-600">
        Placeholder rows for your class schedule. Connect this section to your timetable data when ready.
      </p>
      <ul class="divide-y divide-gray-100 border border-gray-100 rounded-xl overflow-hidden">
        <li v-for="row in sampleRows" :key="row.id"
          class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-6 px-4 py-4 bg-white hover:bg-slate-50/80 transition-colors">
          <span class="text-xs font-semibold uppercase tracking-wide text-blue-700 sm:w-28 shrink-0">{{ row.day }}</span>
          <span class="text-sm font-mono text-gray-800 sm:w-36 shrink-0">{{ row.time }}</span>
          <span class="text-sm font-medium text-gray-900 flex-1">{{ row.course }}</span>
          <span class="text-sm text-gray-600 sm:text-right">{{ row.room }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StudentTimetableView',
  data() {
    return {
      sampleRows: [
        { id: 1, day: 'Monday', time: '08:00 – 09:30', course: 'Anatomy — Lecture', room: 'Hall A' },
        { id: 2, day: 'Wednesday', time: '10:00 – 12:00', course: 'Clinical skills — Lab', room: 'Lab 3' },
        { id: 3, day: 'Friday', time: '14:00 – 15:30', course: 'Research methods — Seminar', room: 'Room 204' }
      ]
    };
  }
};
</script>
